import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

export const WORKSPACE_MOBILE_QUERY = '(max-width:900px)';

export function useWorkspaceFiltersOpen(defaultDesktopOpen = true) {
  const isWorkspaceMobile = useMediaQuery(WORKSPACE_MOBILE_QUERY, { noSsr: true });
  const [filtersOpen, setFiltersOpen] = useState(() => defaultDesktopOpen && !isWorkspaceMobile);

  return [filtersOpen, setFiltersOpen, isWorkspaceMobile];
}

export default useWorkspaceFiltersOpen;
